@import "node_modules/@se/web-ui/styles/se-variable";

.cta-widget-v2 {
  height: 100%;
  display: block;
  &-content-description {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    margin-top: 8px;
  }

  &-header-container {
    max-height: -webkit-fill-available;
    height: 100%;
    display: ruby;
  }

  &-header-title {
    font-weight: 700;
    height: 40px;
    font-size: 18px;
  }

  &-button {
    width: 100%;
  }
}

.extended {
  width: 334px;
  max-width: 334px;
}
